module.exports = __webpack_public_path__ + "img/no_brand_logo.43645e3a.svg";